import { Entity, formatTicker } from '@api';
import { Button } from '@design';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { WatchlistTrigger } from '@terminal/components/watchlist/watchlist-trigger/WatchlistTrigger';
import clsx from 'clsx';
import React from 'react';

import styles from './EntityHeaderWatchlist.module.scss';

export const EntityHeaderWatchlist = ({ entity }: { entity: Entity }) => {
  const ticker = formatTicker(entity);
  const entityName = entity.name_short || entity.name_full;

  return (
    <div className={styles.contentWrapper} data-entity-header-content>
      <div className={styles.tickerWrapper}>
        <span className={styles.ticker}>
          <div className={styles.leftImageContainer}>
            <AssetLogoContainer size={40} entity={entity} />
          </div>
          <div className={styles.titleContainer}>
            <span data-testid={`label${entityName}`}>{entityName}</span>
            <p className={styles.tag}>{ticker}</p>
          </div>
        </span>
      </div>
      <div className={styles.watchlistWrapper}>
        <WatchlistTrigger
          tag={entity.tag}
          dropdownProps={{
            strategy: 'fixed',
            placement: 'top-start',
            inPortal: false,
          }}
          renderTrigger={isInWatchlist => (
            <Button
              className={clsx(styles.customWatchlistButton, {
                [styles.active]: isInWatchlist,
              })}
              data-testid="watchlist-button"
              size="xsmall"
              variant="tertiary"
              iconName={isInWatchlist ? 'Checkmark' : 'Add'}
            />
          )}
        />
      </div>
    </div>
  );
};
